/**
 * PERSONEL KİMLİK SINIRLARI — ürünün `BUSINESS_LIMITS`/`RATE_LIMITS`
 * sözlüklerinden AYRI (Karar 3: "tüm süreçleri ayrı olmalı").
 *
 * Sayıların ürünle aynı olması gereken bir yeri yoktur: personel kovası
 * personelin deneme bütçesidir ve ürün trafiğiyle paylaşılamaz. Aynı değeri
 * taşıyan alanlar bile AYRI yazılır — biri sıkılaştığında diğeri sessizce
 * peşinden gitmesin.
 */
export const STAFF_RATE_LIMITS = {
    /** Varsayılan — özel kural tanımlanmayan personel ucu. */
    default: { ttlSeconds: 60, limit: 60, perIp: true, perAccount: true },
    /**
     * Giriş 1. adım (e-posta + şifre). Tahmin edilen şey bir ŞİFREDİR; bütçe
     * kod denemesiyle PAYLAŞILMAZ. Sunucu ayrıca BAŞARISIZ deneme sayaçları
     * işletir (güvenlik G1, API `StaffLoginAttempts`): (adres, IP) çifti ve
     * yalnız tanınmayan kökene uygulanan adres sayacı.
     *
     * IP sayacı yalnız başarısızı sayar (tur N1): aynı ofis ağından giren
     * personelin doğru girişi kovayı tüketmez.
     */
    login: { ttlSeconds: 900, limit: 10, perIp: true, perAccount: false, ipFailuresOnly: true },
    /** Giriş 2. adım (kod). Ayrı kova: kod bütçesi şifre bütçesini yemez. */
    verify: { ttlSeconds: 900, limit: 10, perIp: true, perAccount: false, ipFailuresOnly: true },
    /** Davet tüketimi (ilk kurulum). Dar: davet jetonu taranamaz. */
    setup: { ttlSeconds: 900, limit: 10, perIp: true, perAccount: false, ipFailuresOnly: true },
    /** Jeton yenileme — döngüye giren paneli frenler. */
    refresh: { ttlSeconds: 60, limit: 30, perIp: true, perAccount: false },
    /**
     * Kendi şifresini değiştirme — oturumlu, dar. Mevcut şifreyi doğrular, yani
     * sır kabul eden uçtur: IP sayacı yalnız başarısızı sayar (tur N1).
     */
    password: { ttlSeconds: 3600, limit: 10, perIp: true, perAccount: true, ipFailuresOnly: true },
    /** Personel hesabı yönetimi (açma/davet/askı) — yalnız admin, dar. */
    accountManage: { ttlSeconds: 3600, limit: 30, perIp: true, perAccount: true },
    /** Kendi durumunu / oturumlarını okuma — panel kabuğu sık çağırır. */
    selfRead: { ttlSeconds: 60, limit: 120, perIp: true, perAccount: true },
    /**
     * PANEL İŞ UÇLARI — OKUMA (S2 devri: 24 iş ucunun okuma yarısı).
     *
     * Ürünün `adminRead` kovasıyla AYNI SAYIYI taşır ama AYRI bir kovadır:
     * ürün trafiği personelin bütçesini yiyemez, personel de ürününkini.
     * Sayının şimdilik eşit olması bir bağ değil, bir başlangıç değeridir.
     */
    panelRead: { ttlSeconds: 60, limit: 120, perIp: true, perAccount: true },
    /** PANEL İŞ UÇLARI — YIKICI EYLEM (askıya alma, karar, yeniden hesaplama). */
    panelAction: { ttlSeconds: 60, limit: 30, perIp: true, perAccount: true },
};
export const STAFF_LIMITS = {
    /** Giriş kodu uzunluğu (hane). */
    loginCodeLength: 6,
    /** Giriş kodu ömrü (dakika). */
    loginCodeTtlMinutes: 10,
    /** Aynı koda izin verilen hatalı deneme sayısı; aşılırsa kod düşer. */
    codeMaxAttempts: 5,
    /** Yeni kod istemeden önce beklenecek süre (saniye). */
    codeResendCooldownSeconds: 60,
    /** Davet (ilk kurulum) jetonunun ömrü — Karar 4c: 48 saat. */
    invitationTtlHours: 48,
    /** Davet jetonu uzunluğu (karakter, base32'ye yakın alfabe). */
    invitationTokenLength: 32,
    /** Aynı personelin aynı anda taşıyabileceği en fazla aktif oturum. */
    maxActiveSessionsPerStaff: 5,
    /** Erişim jetonu ömrü. */
    accessTokenTtl: '15m',
    /**
     * Yenileme jetonu ömrü. ÜRÜNDEN KISA (30 gün → 7 gün) ve bu bilinçlidir:
     * panel oturumu, ürün oturumundan daha değerli bir varlığa açılır.
     */
    refreshTokenTtl: '7d',
    /**
     * Eşzamanlı sekme rotasyon toleransı (saniye). İki sekme aynı anda
     * yenilediğinde bu pencere içindeki tekrar ÇALINMA sayılmaz.
     */
    refreshReuseGraceSeconds: 10,
    /**
     * BAŞARISIZ GİRİŞİN DENETİM DEFTERİNE YAZILMA PENCERESİ (saniye).
     *
     * HIZ KOVASINDAN AYRI BİR SAYIDIR ve öyle kalmalıdır. Dedup bir zamanlar
     * `STAFF_RATE_LIMITS.login` sayacına bağlıydı; o sayaç BAŞARILI girişleri de
     * saydığı için meşru bir girişin açtığı pencerede saldırı defterde HİÇ
     * görünmüyordu (tech-lead S1 · 2. inceleme, ölçüldü: 5 başarısız → 0 satır).
     * Deneme bütçesi ile "bu adres hedef alındı" olgusunun ömrü farklı
     * kavramlardır; biri sıkılaştığında diğeri sessizce peşinden gitmemeli.
     */
    loginFailureAuditWindowSeconds: 900,
    /** Şifre uzunluk tabanı — panel şifresi ürün şifresinden UZUNDUR. */
    passwordMinLength: 12,
    passwordMaxLength: 256,
};
//# sourceMappingURL=staff-limits.js.map